import { ReactNode } from 'react';
import { classNames } from '@/utils/ui/classname';
import styles from './shortcut-tip.module.scss';
import { useShortcutStatus } from '@/editor-hooks/useKeyboardController';
import { EShortcutId } from '@/editor-hooks/types';

interface ShortcutDisplayProps {
  shortcut?: EShortcutId;
  className?: string;
  suffix?: ReactNode;
  prefix?: ReactNode;
}

/**
 * 显示快捷键提示文本的组件
 *
 * 传入 ID 是会根据当前快捷键启用状况判断是否显示
 */
export function ShortcutTip(props: ShortcutDisplayProps) {
  const { shortcut, className } = props;
  const { label } = useShortcutStatus(shortcut);

  return (
    <>
      {props.prefix}
      <kbd className={classNames(styles.shortcutTip, className)}>{label}</kbd>
      {props.suffix}
    </>
  );
}
